<div class="row">
  <div class="col-12">
    <div id="datePickerHolder">
      <input
        type="text"
        placeholder="Date"
        class="form-control theme-dark-blue form-control-sm"
        [bsConfig]="{containerClass: 'theme-dark-blue'}"
        [(ngModel)]="date"
        bsDatepicker />

      <timepicker
        [(ngModel)]="time"
        [showSeconds]="true"
        [showMeridian]="false"
        class="timepicker-no-arrows"></timepicker>
      <button
        class="btn btn-success btn-sm"
        (click)="emitDatetime()"
        (keydown.enter)="emitDatetime()">
        Jump
      </button>
    </div>
  </div>
</div>
